Vue.component("FreshChatContentWrapper", {
  mixins: [SceneContentComponentMixin],
  template: `
        <transition enter-active-class="fadeIn" leave-active-class="fadeOut">
          <component is="FreshChat" :config="config"></component>
        </transition>
    `,
  data() {
    return {
      // scheme
      token: "",
      tags: [],
      headerProperty: {}
    };
  },
  computed: {
    config () {
      return { ...this.$data }
    }
  }
});

touchKit.ComponentManager.register("FreshChatContentWrapper", {
  singleton: true,
});
